import {
    ChangeDetectionStrategy,
    Component,
    computed,
    EventEmitter,
    inject,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    IContactSelected,
    IConversation,
    IVoiceCommand,
} from '@dxp/core/models';
import { VoiceService } from '@dxp/core/services';
import { VoiceApiService } from '@dxp/core/api';
import { delay, filter, of } from 'rxjs';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { WORKITEMS_STORE } from '@dxp/core/stores';

@Component({
    selector: 'voice-contacts-voice-transfer',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './voice-transfer.component.html',
    styleUrl: './voice-transfer.component.scss',
})
export class VoiceContactVoiceTransferComponent implements OnInit {
    readonly #workItemStore = inject(WORKITEMS_STORE);
    readonly #voiceApiService = inject(VoiceApiService);
    readonly #voiceService = inject(VoiceService);

    constructor() {
        toObservable(this.conversation)
            .pipe(
                filter(c => c?.enquiryCallState === 'Disconnected'),
                takeUntilDestroyed(),
            )
            .subscribe(() => {
                this.closeContacts.emit(true);
            });
    }

    @Input({ required: true }) contactSelected!: IContactSelected;
    @Input({ required: true }) conversationId!: string;
    @Input({ required: true }) workItemId!: string;
    @Output() closeContacts = new EventEmitter<boolean>();

    now: Date | undefined;

    conversation = computed<IConversation | undefined>(() => {
        const workItemId = this.workItemId;
        if (!workItemId) return undefined;
        const workItem =
            this.#workItemStore
                .workItems()
                .find(item => item.workItemId === workItemId) || null;
        if (!workItem) return undefined;

        const { conversations } = workItem;
        const foundConversation = conversations.find(
            c => c.conversationId === this.conversationId,
        );

        return foundConversation;
    });

    ngOnInit() {
        const params: IVoiceCommand = {
            conversationId: this.conversationId,
            destination:
                this.contactSelected.type === 'agent'
                    ? `vcc_operators+${this.contactSelected.identifier}`
                    : `${this.contactSelected.identifier}`,
            newCallCommand: 'Transfer',
        };
        this.#voiceService.hideContacts();
        of(params)
            .pipe(delay(2000))
            .subscribe(delayedParams => {
                this.#voiceApiService.callCommand(delayedParams);
            });
        this.now = new Date();
    }
}
